/** AMADA Search: close behavior and Ajax add-to-cart. */
(function () {
  function openCartDrawer() {
    if (window.AmadaCartDrawer && typeof window.AmadaCartDrawer.open === 'function') {
      window.AmadaCartDrawer.open({ justAdded: true });
      return;
    }
    window.location.href = '/cart';
  }

  function addToCart(button) {
    var variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId || button.disabled || typeof fetch !== 'function') return;

    var controller = window.AbortController ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 8000);

    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(openCartDrawer)
      .catch(function () {
        button.classList.add('is-error');
        window.setTimeout(function () { button.classList.remove('is-error'); }, 2000);
      })
      .finally(function () {
        window.clearTimeout(timeout);
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var addButton = target.closest('[data-amada-card-add]');
    if (addButton && addButton.closest('[data-amada-search]')) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      addToCart(addButton);
      return;
    }

    /* Close：一次回到「进搜索之前」的页面（2026-10-06 运营：搜了很多次也要点一次就关掉）。
       原来是 history.back() —— 每搜一次多一条历史，就得多点一次。 */
    var close = target.closest('[data-amada-search-close]');
    if (!close) return;
    event.preventDefault();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    window.location.href = readReturnUrl() || close.getAttribute('href') || '/';
  }, true);

  /* ------------------------------------------------------------------
     进入搜索前的页面：从站内别的页面进来时记下来，之后在搜索页里怎么搜都不覆盖
     ------------------------------------------------------------------ */
  var RETURN_KEY = 'amada:search:return';

  function readReturnUrl() {
    try { return window.sessionStorage.getItem(RETURN_KEY) || ''; } catch (e) { return ''; }
  }

  function rememberReturnUrl() {
    var ref = document.referrer || '';
    if (!ref || ref.indexOf(window.location.origin) !== 0) return;
    var path = '';
    try { path = new URL(ref).pathname; } catch (e) { return; }
    if (/\/search(\/|$)/.test(path)) return; // 搜索页之间跳转不算「进来」
    try { window.sessionStorage.setItem(RETURN_KEY, ref); } catch (e) { /* 存不了就退回首页 */ }
  }

  /* ------------------------------------------------------------------
     实时联想（2026-10-06 运营「全局搜索没生效：搜什么都显示同一个页面」）
     ------------------------------------------------------------------
     原来输入框只是普通表单，打字时页面毫无变化，必须回车才跳结果页。
     现在输入停顿 250ms 就：
       · 右栏：用本 section 自己渲染结果（Section Rendering API，
         /search?q=…&type=product&section_id=<本 section>）→ 与回车后的结果页逐字同款
         （同一张 amada-product-card、同一组后台文案、同一套分页）；
       · 左栏：Shopify 联想（/search/suggest.json）的搜索词 + 系列 + 页面，点了跳对应页面；
         末行「Search for “xxx”」= 回车同效。
     清空输入框 → 两栏还原成进页面时的推荐内容。地址栏同步 replaceState（不新增历史），
     刷新 / 分享链接仍是这次的搜索。所有请求带 8s 超时，慢请求回来时若关键词已变就丢弃。
     ------------------------------------------------------------------ */
  var DEBOUNCE_MS = 250;
  var FETCH_TIMEOUT_MS = 8000;

  function escapeHtml(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function timedFetch(url, accept) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, FETCH_TIMEOUT_MS);
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: accept },
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      window.clearTimeout(timer);
      if (!r.ok) throw new Error('search ' + r.status);
      return accept === 'application/json' ? r.json() : r.text();
    }, function (err) {
      window.clearTimeout(timer);
      throw err;
    });
  }

  function searchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }

  /* 联想词过滤（2026-10-06 运营「有不相关的搜索词」）：联想接口按全网搜索习惯给词，
     会出现 "50 65 tv" 这类店里没有对应商品的词。口径与 sections/amada-search.liquid 的商品字面匹配一致：
     词首匹配、4 字母以上去末尾 s；检索面 = 本次命中商品的 data-amada-search-haystack。 */
  function normWords(text) {
    return String(text || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(function (w) {
      return w.length > 3 && w.charAt(w.length - 1) === 's' ? w.slice(0, -1) : w;
    });
  }

  function hayHasAll(hay, text) {
    var words = normWords(text);
    if (!words.length || !hay) return false;
    var padded = ' ' + hay.toLowerCase().replace(/[^a-z0-9]+/g, ' ') + ' ';
    for (var i = 0; i < words.length; i++) {
      if (padded.indexOf(' ' + words[i]) === -1) return false;
    }
    return true;
  }

  function setupPredictive(root) {
    var input = root.querySelector('[data-amada-search-input]');
    var aside = root.querySelector('.amada-search__suggestions');
    var results = root.querySelector('.amada-search__results');
    var sectionId = root.getAttribute('data-section-id');
    if (!input || !aside || !results || !sectionId || typeof fetch !== 'function') return;

    var original = { aside: aside.innerHTML, results: results.innerHTML, q: input.value.trim() };
    var timer = null;
    var latest = '';

    function renderSuggestions(q, data, hay) {
      var res = (data && data.resources && data.resources.results) || {};
      var links = [];
      /* 搜索词 / 系列：每个词都要能在本次命中的商品里找到，否则点进去是空结果或不相关 */
      (res.queries || []).forEach(function (item) {
        if (!hayHasAll(hay, item.text)) return;
        links.push('<a href="' + escapeHtml(searchUrl(item.text)) + '">' + escapeHtml(item.text) + '</a>');
      });
      (res.collections || []).forEach(function (item) {
        if (!hayHasAll(hay, item.title)) return;
        links.push('<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>');
      });
      /* 页面（政策 / 指南类）不对应商品，按「标题包含全部关键词」保留 */
      (res.pages || []).forEach(function (item) {
        if (!hayHasAll(item.title, q)) return;
        links.push('<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>');
      });
      var heading = root.getAttribute('data-suggestions-heading') || 'Suggestions';
      var allLabel = root.getAttribute('data-search-all-label') || 'Search for';
      links.push('<a class="amada-search__search-all" href="' + escapeHtml(searchUrl(q)) + '">' +
        escapeHtml(allLabel) + ' \u201c' + escapeHtml(q) + '\u201d</a>');
      aside.innerHTML =
        '<div class="amada-search__suggestion-group amada-search__suggestion-group--primary amada-search__suggestion-group--live">' +
          '<h2 class="amada-search__suggestion-title">' + escapeHtml(heading) + '</h2>' +
          '<nav class="amada-search__links">' + links.join('') + '</nav>' +
        '</div>';
    }

    function run(q) {
      latest = q;
      if (!q) {
        aside.innerHTML = original.aside;
        results.innerHTML = original.results;
        root.classList.remove('is-searching');
        try { window.history.replaceState(window.history.state, '', original.q ? searchUrl(original.q) : '/search'); } catch (e) { /* 忽略 */ }
        return;
      }
      root.classList.add('is-searching');
      var sectionReq = timedFetch(searchUrl(q) + '&section_id=' + encodeURIComponent(sectionId), 'text/html');
      var suggestReq = timedFetch(
        '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=query,collection,page&resources%5Blimit%5D=6',
        'application/json'
      ).catch(function () { return null; }); // 联想挂了不影响商品结果

      var hayReq = sectionReq.then(function (html) {
        if (q !== latest) return null; // 用户已经改了关键词，丢弃旧结果
        var box = new DOMParser().parseFromString(html, 'text/html');
        var fresh = box.querySelector('.amada-search__results');
        if (fresh) results.innerHTML = fresh.innerHTML;
        try { window.history.replaceState(window.history.state, '', searchUrl(q)); } catch (e) { /* 忽略 */ }
        return currentHay();
      }).catch(function () { return null; /* 失败保持当前内容，回车仍可走整页搜索 */ });

      Promise.all([hayReq, suggestReq]).then(function (pair) {
        if (q !== latest) return;
        renderSuggestions(q, pair[1], pair[0] || '');
      });
    }

    function currentHay() {
      var grid = results.querySelector('[data-amada-search-haystack]');
      return grid ? grid.getAttribute('data-amada-search-haystack') || '' : '';
    }

    /* 回车进来的结果页：左栏原本是固定分类链接（运营圈出 New Arrival / Area Rug 与 sale 无关），
       同样换成按本次结果过滤的联想；清空输入框时仍还原成分类链接。 */
    if (original.q && results.querySelector('[data-amada-search-haystack]')) {
      latest = original.q;
      timedFetch(
        '/search/suggest.json?q=' + encodeURIComponent(original.q) +
          '&resources%5Btype%5D=query,collection,page&resources%5Blimit%5D=6',
        'application/json'
      ).catch(function () { return null; }).then(function (data) {
        if (latest !== original.q) return;
        renderSuggestions(original.q, data, currentHay());
      });
    }

    input.addEventListener('input', function () {
      if (timer) window.clearTimeout(timer);
      var q = input.value.trim();
      timer = window.setTimeout(function () { run(q); }, q ? DEBOUNCE_MS : 0);
    });
  }

  function init() {
    rememberReturnUrl();
    var roots = document.querySelectorAll('[data-amada-search]');
    for (var i = 0; i < roots.length; i++) setupPredictive(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !document.querySelector('[data-amada-search]')) return;
    var close = document.querySelector('[data-amada-search-close]');
    if (close) close.click();
  });
})();
